module.exports = __webpack_public_path__ + "img/database.c8bfbb6.png";